import { NgModule } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { A11yModule } from '@angular/cdk/a11y';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { PortalModule } from '@angular/cdk/portal';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { CdkStepperModule } from '@angular/cdk/stepper';
import { CdkTableModule } from '@angular/cdk/table';
import { CdkTreeModule } from '@angular/cdk/tree';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatBadgeModule } from '@angular/material/badge';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatStepperModule } from '@angular/material/stepper';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule, MatIconRegistry } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatNativeDateModule, MatRippleModule } from '@angular/material/core';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSliderModule } from '@angular/material/slider';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTreeModule } from '@angular/material/tree';
import { OverlayModule } from '@angular/cdk/overlay';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';

@NgModule({
  declarations: [],
  imports: [
    A11yModule,
    ClipboardModule,
    CdkStepperModule,
    CdkTableModule,
    CdkTreeModule,
    DragDropModule,
    MatAutocompleteModule,
    MatBadgeModule,
    MatBottomSheetModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatStepperModule,
    MatDatepickerModule,
    MatDialogModule,
    MatDividerModule,
    MatExpansionModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatRippleModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    MatTreeModule,
    OverlayModule,
    PortalModule,
    ScrollingModule,
  ],
  exports: [
    A11yModule,
    ClipboardModule,
    CdkStepperModule,
    CdkTableModule,
    CdkTreeModule,
    DragDropModule,
    MatAutocompleteModule,
    MatBadgeModule,
    MatBottomSheetModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatStepperModule,
    MatDatepickerModule,
    MatDialogModule,
    MatDividerModule,
    MatExpansionModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatRippleModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    MatTreeModule,
    OverlayModule,
    PortalModule,
    ScrollingModule,
    MatTooltipModule,
  ],
  providers: [
    { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { float: 'always' } },
  ],
})
export class MaterialComponentsModule {
  constructor(
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer
  ) {
    this.matIconRegistry.addSvgIcon(
      'homeDeposit',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        '../assets/icons/icon-deposit.svg'
      )
    );
    this.matIconRegistry.addSvgIcon(
      'eWallet',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        '../assets/icons/icon-e-wallet.svg'
      )
    );
    this.matIconRegistry.addSvgIcon(
      'homeHistory',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        '../assets/icons/icon-history.svg'
      )
    );
    this.matIconRegistry.addSvgIcon(
      'homeManager',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        '../assets/icons/icon-manager.svg'
      )
    );
    this.matIconRegistry.addSvgIcon(
      'homeWithdraw',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        '../assets/icons/icon-withdraw.svg'
      )
    );

    this.matIconRegistry.addSvgIcon(
      'homeRegisterUser',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        '../assets/icons/icon-registered-user.svg'
      )
    );
    this.matIconRegistry.addSvgIcon(
      'homeTradePerDay',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        '../assets/icons/icon-trades-per-day.svg'
      )
    );
    this.matIconRegistry.addSvgIcon(
      'homeWithdrawnMonthly',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        '../assets/icons/icon-withdrawn-monthly.svg'
      )
    );

    this.matIconRegistry.addSvgIcon(
      'mapMarker',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        '../assets/icons/map-marker.svg'
      )
    );

    this.matIconRegistry.addSvgIcon(
      'email',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        '../assets/icons/email.svg'
      )
    );

    this.matIconRegistry.addSvgIcon(
      'triangleDown',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        '../assets/icons/triangle-down.svg'
      )
    );

    this.matIconRegistry.addSvgIcon(
      'flagEN',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        '../assets/icons/flag-en.svg'
      )
    );

    this.matIconRegistry.addSvgIcon(
      'flagJP',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        '../assets/icons/flag-jp.svg'
      )
    );

    this.matIconRegistry.addSvgIcon(
      'flagVN',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        '../assets/icons/flag-vn.svg'
      )
    );

    this.matIconRegistry.addSvgIcon(
      'platformTitleIcon',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        '../assets/icons/platform-title-icon.svg'
      )
    );

    this.matIconRegistry.addSvgIcon(
      'pfStabilityIcon',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        '../assets/icons/icon-pf-reliability.svg'
      )
    );

    this.matIconRegistry.addSvgIcon(
      'pfPerformanceIcon',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        '../assets/icons/icon-pf-performance.svg'
      )
    );

    this.matIconRegistry.addSvgIcon(
      'pfChartsTimeframesIcon',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        '../assets/icons/icon-pf-charts.svg'
      )
    );

    this.matIconRegistry.addSvgIcon(
      'pfTransactionIcon',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        '../assets/icons/icon-pf-transaction.svg'
      )
    );

    this.matIconRegistry.addSvgIcon(
      'ptnArmchair',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        '../assets/icons/partners-armchair.svg'
      )
    );

    this.matIconRegistry.addSvgIcon(
      'ptnBenefit',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        '../assets/icons/partners-benefit.svg'
      )
    );

    this.matIconRegistry.addSvgIcon(
      'ptnbitcoin',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        '../assets/icons/partners-bitcoin-2.svg'
      )
    );

    this.matIconRegistry.addSvgIcon(
      'ptnBaF',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        '../assets/icons/partners-business-and-finance.svg'
      )
    );

    this.matIconRegistry.addSvgIcon(
      'ptnConnection',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        '../assets/icons/partners-connection.svg'
      )
    );

    this.matIconRegistry.addSvgIcon(
      'ptnHourglass',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        '../assets/icons/partners-hourglass.svg'
      )
    );

    this.matIconRegistry.addSvgIcon(
      'ptnPhone',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        '../assets/icons/partners-mobile-phone.svg'
      )
    );

    this.matIconRegistry.addSvgIcon(
      'ptnWallet',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        '../assets/icons/partners-wallet.svg'
      )
    );

    this.matIconRegistry.addSvgIcon(
      'ptn24Hours',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        '../assets/icons/partners-icon-24-h-trading.svg'
      )
    );

    this.matIconRegistry.addSvgIcon(
      'check',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        '../assets/icons/check.svg'
      )
    );

    this.matIconRegistry.addSvgIcon(
      'plus',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        '../assets/icons/plus.svg'
      )
    );

    this.matIconRegistry.addSvgIcon(
      'minus',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        '../assets/icons/minus.svg'
      )
    );

    this.matIconRegistry.addSvgIcon(
      'giftbox',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        '../assets/icons/giftbox.svg'
      )
    );

    this.matIconRegistry.addSvgIcon(
      'listArrow',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        '../assets/icons/list-arrow.svg'
      )
    );

    this.matIconRegistry.addSvgIcon(
      'menu-icon',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        '../assets/icons/menu.svg'
      )
    );

    this.matIconRegistry.addSvgIcon(
      'exchange-icon',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        '../assets/icons/exchange-icon.svg'
      )
    );
  }
}
